<template>
  <button
    class="c-btn c-btn--blue"
    type="submit"
    :name="name"
    :class="[classes ? classes : '']"
    @click="onClick"
  >
    <span class="c-btn__text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  props: {
    name: String,
    text: String,
    classes: { type: String, required: false },
  },
  emits: ["button-click"],
  methods: {
    onClick: function (event) {
      this.$emit('button-click',event);
    }
  }
}
</script>
